import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class PaymentServices {
  async getAllPaymentTypes(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/payment-type/`, {
        params: { operator: 'ilike', limit: 999 },
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAllActivePaymentTypes(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/payment-type/`, {
        params: { is_active:true, limit: 100, skip:0 },
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCashByByWorkUnit(hash_work_unit: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/cash/parents/${hash_work_unit}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAllPaymentMethods(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/payment-method/`, {
        params: { operator: 'ilike', limit: 999 },
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getPaymentTypesByWorkUnit(hash_work_unit: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-type-by-work-unit/parents/${hash_work_unit}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getPaymentMethodByWorkUnit(token: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-method-by-work-unit/token/${token}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getBankByWorkUnit(token: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/bank/work-unit/${token}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getBankByWorkUnitParents(token: string): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/bank/parents/${token}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }


  async getData(url_with_param: string): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/${url_with_param}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async liquidateExpenses(body: object): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/liquidate/`,
        { ...body },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async tranferCredit(body: object): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/transfer-credit/`,
        { ...body },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async liquidateAirExpenses(body: object): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/liquidate/air/`,
        { ...body },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async liquidateExpensesReservation(body: object): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/liquidate/reservation/`,
        { ...body },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async liquidateExpensesReservations(body: object): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/liquidate/reservations`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getExpensesByItem(hash: string): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/expenses/${hash}/payments`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getExpensesByReservationHash(hash: string): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/expenses/${hash}/credits-used`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getExpensesPaidDetail(accountDetailId: number): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/account-detail/paid-expenses/${accountDetailId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async cancelPayment(payment_entity_id: number): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-entity/cancel/${payment_entity_id}/`,{},
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async unapplyPayments(item_hash: string): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-entity/cancel-by-item/${item_hash}/`,{},
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async returnCredits(body: any): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/reimbursement/set/`,
        body
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getReturned(hash_reservation: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/reimbursement/hash_reservation/value/${hash_reservation}`
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
  async confirmReimbursement(id: number): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/reimbursement/confirm/${id}`,{}
        ,
        {
          headers: { 
            'authentication-token': getJWT()!,
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async cancelReimbursement(id: number): Promise<any[]> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/reimbursement/cancel/${id}`,{}
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCreditsUnused(reserve_hash:string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/${reserve_hash}/credits-unused`
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getPaymentOrigin(id:number): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/account-detail/payment-origin/${id}`
        ,
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateCredit(hash_item:string): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/item-aftersales/credits/${hash_item}`
        ,{},
        {
          headers: { 
            'authentication-token': getJWT()!
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async applyCredits(hash_reservation :string): Promise<any[]> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/expenses/credits/automatically/apply`
        ,
        {
          'hash_reservation' : hash_reservation 
        },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const paymentServices = new PaymentServices()
